import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_header = _resolveComponent("el-header")!
  const _component_el_container = _resolveComponent("el-container")!

  return (_openBlock(), _createBlock(_component_el_container, null, {
    default: _withCtx(() => [
      _createVNode(_component_el_header, { class: "permissions-page__header" }, {
        default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
          _createElementVNode("h3", { class: "permissions-page__header_title" }, " Hello, I'm new service permission page (please, don't forget to change this name to the real one) ", -1 /* CACHED */),
          _createElementVNode("hr", null, null, -1 /* CACHED */)
        ]))]),
        _: 1 /* STABLE */
      }),
      _createElementVNode("div", null, [
        _createElementVNode("p", null, [
          _cache[1] || (_cache[1] = _createTextVNode("Backoffice api url: ", -1 /* CACHED */)),
          _createElementVNode("b", null, _toDisplayString(_ctx.BACKOFFICE_API_URL), 1 /* TEXT */)
        ]),
        _createElementVNode("p", null, [
          _cache[2] || (_cache[2] = _createTextVNode("Backoffice api token: ", -1 /* CACHED */)),
          _createElementVNode("b", null, _toDisplayString(_ctx.token ? '✅' : '❌'), 1 /* TEXT */)
        ]),
        _createElementVNode("p", null, [
          _cache[3] || (_cache[3] = _createTextVNode("WL SLUG: ", -1 /* CACHED */)),
          _createElementVNode("b", null, _toDisplayString(_ctx.WL_SLUG), 1 /* TEXT */)
        ]),
        _createElementVNode("p", null, [
          _cache[4] || (_cache[4] = _createTextVNode("Current parrent route name: ", -1 /* CACHED */)),
          _createElementVNode("b", null, _toDisplayString(_ctx.CURRENT_PARTENT_ROUTE_NAME), 1 /* TEXT */)
        ])
      ]),
      _createElementVNode("div", null, [
        _cache[7] || (_cache[7] = _createElementVNode("h3", null, "Sections permissions", -1 /* CACHED */)),
        _cache[8] || (_cache[8] = _createElementVNode("br", null, null, -1 /* CACHED */)),
        _createElementVNode("section", null, [
          _createElementVNode("ul", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.newServicePermissions, (sectionPermissions, sectionName) => {
              return (_openBlock(), _createElementBlock("li", { key: sectionName }, [
                _createElementVNode("h4", null, _toDisplayString(sectionName), 1 /* TEXT */),
                _createElementVNode("div", null, [
                  _cache[5] || (_cache[5] = _createTextVNode(" Permissions list: ", -1 /* CACHED */)),
                  _createElementVNode("ul", null, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(sectionPermissions, (permissionValue, permissionName) => {
                      return (_openBlock(), _createElementBlock("li", { key: permissionName }, _toDisplayString(permissionValue ? '✅' : '❌') + "   " + _toDisplayString(permissionName), 1 /* TEXT */))
                    }), 128 /* KEYED_FRAGMENT */))
                  ])
                ]),
                _cache[6] || (_cache[6] = _createElementVNode("hr", null, null, -1 /* CACHED */))
              ]))
            }), 128 /* KEYED_FRAGMENT */))
          ])
        ])
      ])
    ]),
    _: 1 /* STABLE */
  }))
}